import { ENV_IS_LOCAL_AUTH } from 'constants/env';

export const isLocalAuthEnabled = () => ENV_IS_LOCAL_AUTH;
